import { create } from "zustand";

type TChapterMemoStatus = {
  id: number;
  hasActiveMemo: boolean;
  chapterName: string;
};

interface ChapterMemoStore {
  chaptersByProject: Record<string, TChapterMemoStatus[]>;
  setChapters: (projectId: string, chapters: TChapterMemoStatus[]) => void;
  getChapters: (projectId: string) => TChapterMemoStatus[];
  clearChapters: (projectId: string) => void;
  markChapterAsLoaded: (chapterId: number) => void;
}

export const useChapterMemoStore = create<ChapterMemoStore>()((set, get) => ({
  chaptersByProject: {},

  setChapters: (projectId, chapters) =>
    set((state) => ({
      chaptersByProject: { ...state.chaptersByProject, [projectId]: chapters }
    })),

  getChapters: (projectId) => get().chaptersByProject[projectId] || [],

  clearChapters: (projectId) =>
    set((state) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [projectId]: _, ...rest } = state.chaptersByProject;
      return { chaptersByProject: rest };
    }),

  markChapterAsLoaded: (chapterId) =>
    set((state) => {
      const updatedProjects: Record<string, TChapterMemoStatus[]> = {};

      Object.entries(state.chaptersByProject).forEach(([projectId, chapters]) => {
        updatedProjects[projectId] = chapters.map((chapter) =>
          chapter.id === chapterId ? { ...chapter, hasActiveMemo: true } : chapter
        );
      });

      return { chaptersByProject: updatedProjects };
    })
}));
